import React, { useState } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import axios from 'axios'
import FormField from '../../utils/FormField'

const MIN_PASSWORD_LENGTH = 8

export default function ResetPassword() {
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token') || ''
  const navigate = useNavigate()

  const [state, setState] = useState({})
  const [submitting, setSubmitting] = useState(false)
  const [done, setDone] = useState(false)
  const [error, setError] = useState(null)

  const onChange = (event) => {
    const { name, value } = event.target
    setState((prevState) => ({ ...prevState, [name]: value }))
  }

  const onSubmit = async (event) => {
    event.preventDefault()
    if ((state.password || '').length < MIN_PASSWORD_LENGTH) {
      return setError(`Password must be at least ${MIN_PASSWORD_LENGTH} characters.`)
    }
    if (state.password !== state.confirmPassword) {
      return setError('Those passwords do not match.')
    }
    setSubmitting(true)
    setError(null)
    try {
      await axios.post('/api/v1/auth/reset-password', { token, password: state.password })
      setDone(true)
      setTimeout(() => navigate('/signin'), 2500)
    } catch (requestError) {
      setError(requestError?.response?.data?.error || 'Could not reset the password. Please try again.')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 px-6 lg:px-8">
      <div className="mt-8 mx-auto w-full max-w-lg">
        <div className="bg-white pb-4 pt-2 shadow rounded-lg px-5 lg:pb-8 lg:pt-4 lg:px-10">
          <img src="/brand/eadin-logo-full.png" alt="Eadin" className="h-14 w-auto mx-auto mb-4" />
          {done ? (
            <>
              <p className="text-sm text-gray-700">Your password has been updated. Taking you to sign in…</p>
              <Link to="/signin" className="mt-6 inline-block text-sm text-gray-600 underline">
                Sign in now
              </Link>
            </>
          ) : !token ? (
            <>
              <p className="text-sm text-red-600">This reset link is incomplete. Request a new one.</p>
              <Link to="/forgot-password" className="mt-6 inline-block text-sm text-gray-600 underline">
                Request a new link
              </Link>
            </>
          ) : (
            <>
              <h1 className="text-base font-medium text-gray-900">Choose a new password</h1>
              <p className="mt-1 mb-6 text-sm text-gray-500">
                Reset links expire 30 minutes after they are sent and can only be used once.
              </p>
              {error ? <p className="mb-4 text-sm text-red-600">{error}</p> : null}
              <form className="space-y-6" onSubmit={onSubmit}>
                <FormField
                  label="New Password"
                  field="password"
                  type="password"
                  onChange={onChange}
                  autoComplete="new-password"
                  state={state}
                />
                <FormField
                  label="Confirm New Password"
                  field="confirmPassword"
                  type="password"
                  onChange={onChange}
                  autoComplete="new-password"
                  state={state}
                />
                <div className="flex items-center gap-4">
                  <button
                    type="submit"
                    disabled={submitting}
                    className="bg-[#111] hover:bg-black text-white px-4 py-2 rounded-md text-sm disabled:opacity-50"
                  >
                    {submitting ? 'Saving…' : 'Set new password'}
                  </button>
                  <Link to="/signin" className="text-sm text-gray-600 underline">
                    Back to sign in
                  </Link>
                </div>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
